import React from 'react';
import { Space } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

import * as S from './styles';

export function FinalService() {
  return <S.Container>
    <Space>
      <CheckCircleOutlined
        style={{
          fontSize: '117px',
          color: '#24A95D',
          marginBottom: 23,
        }}
      />
    </Space>
    <Space>
      <S.TextCustom bold color="#24A95D">
        Atendimento finalizado
      </S.TextCustom>
    </Space>
         </S.Container>;
}
